var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.consultar(false)
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _vm._v(" "),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-md-3",
                staticStyle: { "white-space": "nowrap" }
              },
              [
                _c(
                  "div",
                  { staticClass: "select2-field select2-field--stretch" },
                  [
                    _c("v-select", {
                      attrs: {
                        id: "plantilla",
                        label: "descripcion",
                        options: _vm.plantillas
                      },
                      on: { input: _vm.inputPlantilla },
                      model: {
                        value: _vm.selectedPlantilla,
                        callback: function($$v) {
                          _vm.selectedPlantilla = $$v
                        },
                        expression: "selectedPlantilla"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "plantilla" } }, [
                      _vm._v("Tipo reporte")
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: { id: "yard", multiple: "", options: _vm.patios },
                    on: { input: _vm.inputYard },
                    model: {
                      value: _vm.form.yard_code,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "yard_code", $$v)
                      },
                      expression: "form.yard_code"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "yard" } }, [_vm._v("Yard")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "status",
                      label: "name",
                      multiple: "",
                      options: _vm.estados
                    },
                    on: { input: _vm.inputStatus },
                    model: {
                      value: _vm.selectedStatus,
                      callback: function($$v) {
                        _vm.selectedStatus = $$v
                      },
                      expression: "selectedStatus"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "status" } }, [_vm._v("Status")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "customer",
                      label: "name",
                      multiple: "",
                      options: _vm.customers
                    },
                    on: { input: _vm.inputCustomer },
                    model: {
                      value: _vm.selectedCustomer,
                      callback: function($$v) {
                        _vm.selectedCustomer = $$v
                      },
                      expression: "selectedCustomer"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "customer" } }, [
                    _vm._v("Customers")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "type",
                      label: "descripcion",
                      options: _vm.types
                    },
                    on: { input: _vm.inputType },
                    model: {
                      value: _vm.selectedType,
                      callback: function($$v) {
                        _vm.selectedType = $$v
                      },
                      expression: "selectedType"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "type" } }, [_vm._v("Type")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha,
                          expression: "form.tipo_fecha"
                        }
                      ],
                      attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "tipo_fecha",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "T" } }, [
                        _vm._v("Todas")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "H" } }, [_vm._v("Hoy")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "A" } }, [_vm._v("Ayer")]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Personalizada")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipo_fecha" } }, [
                    _vm._v("Tipo de fecha")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-2"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: { type: "date", id: "desde" },
                        on: { enterkey: _vm.consultar },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "desde" } }, [
                        _vm._v("Desde")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.tipo_fecha === "P",
                    expression: "form.tipo_fecha === 'P'"
                  }
                ],
                staticClass: "col-xs-12 col-md-2"
              },
              [
                _c("div", { staticClass: "form-field" }, [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("date-picker", {
                        attrs: { type: "date", id: "hasta" },
                        on: { enterkey: _vm.consultar },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "hasta" } }, [
                        _vm._v("Hasta")
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-2" }, [
              _c(
                "div",
                { staticClass: "select2-field select2-field--stretch" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "tipo",
                      label: "descripcion",
                      options: _vm.tipos
                    },
                    on: { input: _vm.inputTipo },
                    model: {
                      value: _vm.selectedTipo,
                      callback: function($$v) {
                        _vm.selectedTipo = $$v
                      },
                      expression: "selectedTipo"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "card card--collapsible mt-3 mb-3" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-xs-12",
                staticStyle: {
                  "max-height": "280px",
                  height: "auto",
                  "overflow-y": "scroll"
                }
              },
              [
                _c("checked-listbox", {
                  attrs: {
                    items: _vm.columnas,
                    columns: 4,
                    name: "columnas[]",
                    field: "nombre"
                  },
                  on: { input: _vm.inputColumna },
                  model: {
                    value: _vm.form.columnas,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "columnas", $$v)
                    },
                    expression: "form.columnas"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "details",
        {
          staticClass: "card card--collapsible mt-3 mb-3",
          attrs: { open: "" }
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content", staticStyle: { height: "auto" } },
            [
              _c("dynamic-table", {
                ref: "table",
                attrs: {
                  colorTd: "",
                  colorTh: "",
                  columnasInvisibles: _vm.form.columnasInvisibles,
                  columnas: _vm.columns,
                  registros: _vm.registros,
                  totalItems: _vm.totalItems,
                  currentPage: _vm.form.currentPage,
                  registrosPorPagina: _vm.form.registrosPorPagina,
                  mostrarSelectedMultiple: true,
                  mostrarRegistrosTotales: true,
                  columnasCheck: _vm.columnasCheck,
                  columnasBox: _vm.columnasBox,
                  columnasMac: _vm.columnasMac
                },
                on: {
                  handleSort: _vm.handleSort,
                  handleChangePage: _vm.handleChangePage,
                  filtrarBusqueda: _vm.filtrarBusqueda,
                  seleccionado: _vm.rowSeleccionado,
                  handleSelected: _vm.handleSelected
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.registros.length !== 0,
                      expression: "registros.length !== 0"
                    }
                  ],
                  staticClass: "col-md-12 form-inline"
                },
                [
                  _c("div", [
                    _c("p", [_vm._v("Amount.B (p): " + _vm._s(_vm.pag_a_b))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("Amount.B (t): " + _vm._s(_vm.total_a_b))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("MH.B (p): " + _vm._s(_vm.pag_mh_b))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("MH.B (t): " + _vm._s(_vm.total_mh_b))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("Amount.M (p): " + _vm._s(_vm.pag_a_m))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("Amount.M (t): " + _vm._s(_vm.total_a_m))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("MH.M (p): " + _vm._s(_vm.pag_mh_m))])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", [_vm._v("MH.M (t): " + _vm._s(_vm.total_mh_m))])
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            width: "75%",
            height: "auto",
            scrollable: "",
            name: "editarPropiedades"
          }
        },
        [
          _c("editar-unidad", {
            ref: "editarUnidad",
            attrs: {
              soloEdicion: "",
              historico: _vm.currentSecuencia == "" ? false : true,
              numeroContenedor: _vm.currentNumber,
              numeroSecuencia: _vm.currentSecuencia,
              puede_editar_gate_in: _vm.puede_editar_gate_in,
              puede_editar_gate_out: _vm.puede_editar_gate_out,
              puede_editar_in: _vm.puede_editar_in,
              puede_editar_out: _vm.puede_editar_out,
              puede_editar_caja: _vm.puede_editar_caja,
              puede_editar_maquina: _vm.puede_editar_maquina,
              puede_enviar_edi_in: _vm.puede_enviar_edi_in,
              puede_enviar_edi_out: _vm.puede_enviar_edi_out,
              puede_editar_status: _vm.puede_editar_status,
              puede_eliminar: _vm.puede_eliminar
            },
            on: {
              cerrarUnidad: _vm.cerrarUnidad,
              eliminarUnidad: _vm.eliminarUnidad
            },
            model: {
              value: _vm.currentUnidad,
              callback: function($$v) {
                _vm.currentUnidad = $$v
              },
              expression: "currentUnidad"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte General")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-primary" },
      [
        _c("div", { staticClass: "form-inline" }, [
          _c("i", {
            staticClass: "fa fa-info-circle",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("h5", [_vm._v("Datos a mostrar")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-primary" },
      [
        _c("div", { staticClass: "form-inline" }, [
          _c("i", {
            staticClass: "fa fa-info-circle",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" "),
          _c("h5", [_vm._v("Resultados")])
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-758adc7d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758adc7d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/ReporteGeneral.vue
// module id = 439
// module chunks = 0